// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KKYj3","footer":"styles_footer__JZy-f","passCodeTooltip":"styles_passCodeTooltip__ZRC9J"};